import { SelectProps } from "../types";

export const useSelectMode = (
  type: SelectProps["type"],
  searchable?: SelectProps["searchable"]
) => ({
  isSingleMode: type === "single",
  isMultipleMode: type === "multiple",
  isSearchableMode: Boolean(searchable),
});
